import script from "./ConnectQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./style.scss?vue&type=style&index=0&id=abe5abec&lang=scss&scoped=true"
import "./ConnectQuestion.vue?vue&type=style&index=1&id=abe5abec&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abe5abec"]])

export default __exports__